import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Box, Card, CardContent } from '@mui/material';
import { ROUTES } from '../../../config/routes';
import ArticuloInfo360Contenido from './ArticuloInfo360Contenido';
import ArticuloInfo360Header from './components/ArticuloInfo360Header';
import { invalidateInfo360Cache } from './info360ProductoCache';

function safeReturnTo(raw: string | null): string | null {
  if (!raw) return null;
  const value = raw.trim();
  if (!value.startsWith('/') || value.startsWith('//')) return null;
  return value;
}

const ProductoInfo360: React.FC = () => {
  const { codigoArticulo: codigoParam } = useParams<{ codigoArticulo: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const codigoArticulo = decodeURIComponent(codigoParam ?? '').trim();
  const returnTo = safeReturnTo(searchParams.get('returnTo'));

  const handleVolver = () => {
    if (returnTo) {
      navigate(returnTo);
      return;
    }
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate(ROUTES.inventario.productos.list);
  };

  return (
    <Box sx={{ p: { xs: 2, sm: 3 }, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      <Card
        sx={{
          bgcolor: '#ffffff',
          borderRadius: 3,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          overflow: 'hidden',
        }}
      >
        <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
          <ArticuloInfo360Contenido
            codigoArticulo={codigoArticulo}
            accionSecundariaError={{ label: 'Volver', onClick: handleVolver }}
            renderHeader={(producto) => (
              <ArticuloInfo360Header
                producto={producto}
                onVolver={handleVolver}
                onEditarMaestro={() => {
                  invalidateInfo360Cache(producto.codigoArticulo);
                  navigate(ROUTES.inventario.productos.editar(producto.codigoArticulo));
                }}
              />
            )}
          />
        </CardContent>
      </Card>
    </Box>
  );
};

export default ProductoInfo360;
